import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { ChatEntry } from '@/components/livekit/chat/chat-entry';
import { cn } from '@/lib/utils';
const ChatEntryMotion = motion.create(ChatEntry);
export function Transcript({ ref, messages, className, }) {
    const transcriptRef = useRef(null);
    const handleRef = useCallback((node) => {
        transcriptRef.current = node;
        if (ref) {
            if (typeof ref === 'function') {
                ref(node);
            }
            else {
                ref.current = node;
            }
        }
    }, [ref]);
    // auto scroll transcript
    useEffect(() => {
        function scrollToBottom() {
            const scrollingElement = transcriptRef.current;
            if (scrollingElement) {
                scrollingElement.scrollTop = scrollingElement.scrollHeight;
            }
        }
        if (transcriptRef.current) {
            const resizeObserver = new ResizeObserver(scrollToBottom);
            resizeObserver.observe(transcriptRef.current);
            scrollToBottom();
            return () => resizeObserver.disconnect();
        }
    }, [messages]);
    return (_jsx("div", { ref: handleRef, className: cn('scrollbar-on-hover flex grow flex-col overflow-x-hidden overflow-y-scroll py-3 pr-3 pl-1', '[mask-image:linear-gradient(0deg,rgba(0,0,0,0.2)_0%,rgba(0,0,0,1)_5%,rgba(0,0,0,1)_95%,rgba(0,0,0,0)_100%)]', className), children: _jsx("div", { className: "flex flex-1 flex-col justify-end gap-2 pt-16", children: _jsx(AnimatePresence, { children: messages.map((message) => (_jsx(ChatEntryMotion, { hideName: true, initial: { opacity: 0, height: 0 }, animate: { opacity: 1, height: 'auto' }, exit: { opacity: 1, height: 'auto', translateY: 0.001 }, transition: { duration: 0.5, ease: 'easeOut' }, entry: message }, message.id))) }) }) }));
}
